import Icon from '../components/Icon.vue'

Icon.register({"object-group":{"width":2048,"height":1792,"paths":[{"d":"M2048 384h-128v1024h128v384h-384v-128h-1280v128h-384v-384h128v-1024h-128v-384h384v128h1280v-128h384v384zM1792 128v128h128v-128h-128zM128 128v128h128v-128h-128zM256 1664v-128h-128v128h128zM1664 1536v-128h128v-1024h-128v-128h-1280v128h-128v1024h128v128h1280zM1920 1664v-128h-128v128h128zM1280 640h384v768h-896v-256h-384v-768h896v256zM512 1024h640v-512h-640v512zM1536 1280v-512h-256v384h-384v128h640z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/object-group.js
// module id = 754
// module chunks = 0